
import { ofArray, toArray, sortWith } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { sortAsc } from "../SharedComponents/NaturalOrder.js";
import { createElement } from "react";
import React from "react";
import { reactApi as reactApi_1, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useTranslation } from "react-i18next";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { trimStart, concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { takeWhile, singleton, empty, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { defaultOf } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import react_select from "react-select";
import { newGuid } from "../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import creatable from "react-select/creatable";

export function defaultStyling(state) {
    return {
        "&": {
            borderColor: "",
        },
        "&:hover": {
            borderColor: "",
        },
        borderColor: state.isFocused ? "#14BC9C" : "#B6BECB",
        boxShadow: "none",
    };
}

export function invalidStyling(state) {
    const borderColor = state.isFocused ? "#14BC9C" : "#EB4D4D";
    return {
        "&": {
            borderColor: borderColor,
        },
        "&:hover": {
            borderColor: borderColor,
        },
        borderColor: borderColor,
        boxShadow: "none",
    };
}

export function orderOptions(options) {
    return sortWith((a, b) => (sortAsc(a.label, b.label) | 0), options);
}

function NoOptionsMessage(noOptionsMessageInputProps) {
    const props = noOptionsMessageInputProps.props;
    const text = noOptionsMessageInputProps.text;
    return reactElement("div", {
        className: "mr-auto p-2",
        children: text,
    });
}

export function Select(props) {
    let elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["data-test-id", props.TestId], ["className", join(" ", [])], (elems = toList(delay(() => {
        let matchValue, label;
        return append((matchValue = props.Label, (matchValue == null) ? (empty()) : ((label = matchValue, singleton(reactElement("label", {
            className: join(" ", ["text-sm", "font-bold"]),
            children: label,
        }))))), delay(() => {
            let props_2, text, value_10;
            return append(singleton((props_2 = ofArray([["options", toArray(props.Options)], ["placeholder", t(props.PlaceholderKey)], ["onChange", props.OnChange], ["noOptionsMessage", (text = t(props.NoOptionsMessage), (props_1) => createElement(NoOptionsMessage, {
                text: text,
                props: props_1,
            }))], (value_10 = props.Value, ["value", (value_10 == null) ? defaultOf() : value_10]), ["isClearable", props.IsClearable], ["isDisabled", props.ComponentState === "disabled"], ["styles", {
                control: (baseStyles, state) => (Object.assign({}, baseStyles, ((props.ValidationMessage == null) ? defaultStyling(state) : invalidStyling(state)))),
                menuPortal: (baseStyles_1, state_1) => (Object.assign({}, baseStyles_1, {
                    zIndex: 9999,
                })),
            }], ["menuPortalTarget", document.body], ["menuPosition", "fixed"]]), reactApi.createElement(react_select, createObj(props_2)))), delay(() => {
                const matchValue_2 = props.ValidationMessage;
                if (matchValue_2 == null) {
                    return empty();
                }
                else {
                    const message = matchValue_2;
                    return singleton(reactElement("div", {
                        className: join(" ", ["mt-2", "text-red", "text-sm"]),
                        children: message,
                    }));
                }
            }));
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
}

export function SearchableSelect(props) {
    let elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["data-test-id", props.TestId], ["className", join(" ", [])], (elems = toList(delay(() => {
        let matchValue, label;
        return append((matchValue = props.Label, (matchValue == null) ? (empty()) : ((label = matchValue, singleton(reactElement("label", {
            className: join(" ", ["text-sm", "font-bold"]),
            children: label,
        }))))), delay(() => {
            let props_2, text, value_11;
            return append(singleton((props_2 = ofArray([["options", toArray(props.Options)], ["placeholder", t(props.PlaceholderKey)], ["onChange", props.OnChange], ["onInputChange", (input, _arg) => {
                props.OnInputChange(input);
            }], ["noOptionsMessage", (text = t(props.NoOptionsMessage), (props_1) => createElement(NoOptionsMessage, {
                text: text,
                props: props_1,
            }))], (value_11 = props.Value, ["value", (value_11 == null) ? defaultOf() : value_11]), ["isClearable", props.IsClearable], ["isDisabled", props.ComponentState === "disabled"], ["styles", {
                control: (baseStyles, state) => (Object.assign({}, baseStyles, ((props.ValidationMessage == null) ? defaultStyling(state) : invalidStyling(state)))),
                menuPortal: (baseStyles_1, state_1) => (Object.assign({}, baseStyles_1, {
                    zIndex: 9999,
                })),
            }], ["menuPortalTarget", document.body], ["menuPosition", "fixed"]]), reactApi.createElement(react_select, createObj(props_2)))), delay(() => {
                const matchValue_2 = props.ValidationMessage;
                if (matchValue_2 == null) {
                    return empty();
                }
                else {
                    const message = matchValue_2;
                    return singleton(reactElement("div", {
                        className: join(" ", ["mt-2", "text-red", "text-sm"]),
                        children: message,
                    }));
                }
            }));
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
}

export function MultiSelect(props) {
    let elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["data-test-id", props.TestId], (elems = toList(delay(() => {
        let matchValue, label;
        return append((matchValue = props.Label, (matchValue == null) ? (empty()) : ((label = matchValue, singleton(reactElement("label", {
            className: join(" ", ["text-sm", "font-bold"]),
            children: label,
        }))))), delay(() => {
            let props_2, text;
            return append(singleton((props_2 = ofArray([["options", toArray(props.Options)], ["placeholder", t(props.PlaceholderKey)], ["onChange", props.OnChange], ["noOptionsMessage", (text = t(props.NoOptionsMessage), (props_1) => createElement(NoOptionsMessage, {
                text: text,
                props: props_1,
            }))], ["value", toArray(props.Value)], ["isClearable", props.IsClearable], ["isMulti", true], ["isDisabled", props.ComponentState === "disabled"], ["styles", {
                control: (baseStyles, state) => (Object.assign({}, baseStyles, ((props.ValidationMessage == null) ? defaultStyling(state) : invalidStyling(state)))),
                menuPortal: (baseStyles_1, state_1) => (Object.assign({}, baseStyles_1, {
                    zIndex: 9999,
                })),
            }], ["menuPortalTarget", document.body], ["menuPosition", "fixed"]]), reactApi.createElement(react_select, createObj(props_2)))), delay(() => {
                const matchValue_2 = props.ValidationMessage;
                if (matchValue_2 == null) {
                    return empty();
                }
                else {
                    const message = matchValue_2;
                    return singleton(reactElement("div", {
                        className: join(" ", ["mt-2", "text-red", "text-sm"]),
                        children: message,
                    }));
                }
            }));
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
}

export function GroupedSelect(props) {
    let elems_2, elems_1, elems;
    const id = newGuid();
    const t = useTranslation()[0];
    const matchValue = props.Label;
    if (matchValue == null) {
        return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_2 = toList(delay(() => {
            let props_4, value_29, text_1;
            return append(singleton((props_4 = ofArray([["key", concat("grouped-select-key-", ...props.Key)], (value_29 = props.Value, ["value", (value_29 == null) ? defaultOf() : value_29]), ["options", toArray(props.Options)], ["placeholder", t(props.PlaceholderKey)], ["onChange", props.OnChange], ["noOptionsMessage", (text_1 = t(props.NoOptionsMessage), (props_3) => createElement(NoOptionsMessage, {
                text: text_1,
                props: props_3,
            }))], ["formatGroupLabel", (groupOption_1) => reactElement("span", {
                children: [groupOption_1.label],
            })], ["isClearable", props.IsClearable], ["isDisabled", props.ComponentState === "disabled"], ["styles", {
                control: (baseStyles_2, state_2) => (Object.assign({}, baseStyles_2, defaultStyling(state_2))),
                menuPortal: (baseStyles_3, state_3) => (Object.assign({}, baseStyles_3, {
                    zIndex: 9999,
                })),
            }], ["menuPortalTarget", document.body], ["menuPosition", "fixed"]]), reactApi.createElement(react_select, createObj(props_4)))), delay(() => {
                const matchValue_2 = props.ValidationMessage;
                if (matchValue_2 == null) {
                    return empty();
                }
                else {
                    const message_1 = matchValue_2;
                    return singleton(reactElement("div", {
                        className: join(" ", ["mt-2", "text-red", "text-sm"]),
                        children: message_1,
                    }));
                }
            }));
        })), ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])));
    }
    else {
        const label = matchValue;
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1.5"])], (elems_1 = [reactElement("label", {
            htmlFor: id,
            className: join(" ", ["text-sm", "font-bold"]),
            children: label,
        }), reactElement("div", createObj(ofArray([["data-test-id", concat(label, ..."-test-id")], (elems = toList(delay(() => {
            let props_2, value_10, text;
            return append(singleton((props_2 = ofArray([["key", concat("grouped-select-key-", ...props.Key)], (value_10 = props.Value, ["value", (value_10 == null) ? defaultOf() : value_10]), ["options", toArray(props.Options)], ["placeholder", t(props.PlaceholderKey)], ["onChange", props.OnChange], ["noOptionsMessage", (text = t(props.NoOptionsMessage), (props_1) => createElement(NoOptionsMessage, {
                text: text,
                props: props_1,
            }))], ["formatGroupLabel", (groupOption) => reactElement("span", {
                children: [groupOption.label],
            })], ["isClearable", props.IsClearable], ["isDisabled", props.ComponentState === "disabled"], ["styles", {
                control: (baseStyles, state) => (Object.assign({}, baseStyles, defaultStyling(state))),
                menuPortal: (baseStyles_1, state_1) => (Object.assign({}, baseStyles_1, {
                    zIndex: 9999,
                })),
            }], ["menuPortalTarget", document.body], ["menuPosition", "fixed"]]), reactApi.createElement(react_select, createObj(props_2)))), delay(() => {
                const matchValue_1 = props.ValidationMessage;
                if (matchValue_1 == null) {
                    return empty();
                }
                else {
                    const message = matchValue_1;
                    return singleton(reactElement("div", {
                        className: join(" ", ["mt-2", "text-red", "text-sm"]),
                        children: message,
                    }));
                }
            }));
        })), ["children", reactApi_1.Children.toArray(Array.from(elems))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])));
    }
}

export function GroupedSelectMulti(props) {
    let elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["data-test-id", props.TestId], (elems = toList(delay(() => {
        let matchValue, label;
        return append((matchValue = props.Label, (matchValue == null) ? (empty()) : ((label = matchValue, singleton(reactElement("label", {
            className: join(" ", ["text-sm", "font-bold"]),
            children: label,
        }))))), delay(() => {
            let props_2, text;
            return append(singleton((props_2 = ofArray([["isMulti", true], ["options", toArray(props.Options)], ["placeholder", t(props.PlaceholderKey)], ["onChange", props.OnChange], ["noOptionsMessage", (text = t(props.NoOptionsMessage), (props_1) => createElement(NoOptionsMessage, {
                text: text,
                props: props_1,
            }))], ["value", toArray(props.Value)], ["formatGroupLabel", (groupOption) => reactElement("span", {
                children: [groupOption.label],
            })], ["isClearable", props.IsClearable], ["isMulti", true], ["isDisabled", props.ComponentState === "disabled"], ["styles", {
                control: (baseStyles, state) => (Object.assign({}, baseStyles, ((props.ValidationMessage == null) ? defaultStyling(state) : invalidStyling(state)))),
                menuPortal: (baseStyles_1, state_1) => (Object.assign({}, baseStyles_1, {
                    zIndex: 9999,
                })),
            }], ["menuPortalTarget", document.body], ["menuPosition", "fixed"]]), reactApi.createElement(react_select, createObj(props_2)))), delay(() => {
                const matchValue_2 = props.ValidationMessage;
                if (matchValue_2 == null) {
                    return empty();
                }
                else {
                    const message = matchValue_2;
                    return singleton(reactElement("div", {
                        className: join(" ", ["mt-2", "text-red", "text-sm"]),
                        children: message,
                    }));
                }
            }));
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
}

function colorDotLabel(option) {
    let elems;
    const label = option.label;
    let color;
    try {
        color = option.color;
    }
    catch (matchValue) {
        color = undefined;
    }
    const indent = join("", takeWhile((c) => (c === " "), label.split("")));
    const text = trimStart(label, " ");
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center"])], (elems = toList(delay(() => append((indent.length > 0) ? singleton(reactElement("span", {
        style: {
            whiteSpace: "pre",
        },
        children: indent,
    })) : empty(), delay(() => {
        let matchValue_1, c_2;
        return append((matchValue_1 = color, (matchValue_1 != null) ? ((matchValue_1 !== "") ? ((c_2 = matchValue_1, singleton(reactElement("div", {
            className: join(" ", ["w-3", "h-3", "rounded-full", "flex-shrink-0", "mr-2"]),
            style: {
                backgroundColor: c_2,
            },
        })))) : (empty())) : (empty())), delay(() => singleton(reactElement("span", {
            children: text,
        }))));
    })))), ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
}

export function SelectWithColor(props) {
    let elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["data-test-id", props.TestId], (elems = toList(delay(() => {
        let matchValue, label;
        return append((matchValue = props.Label, (matchValue == null) ? (empty()) : ((label = matchValue, singleton(reactElement("label", {
            className: join(" ", ["text-sm", "font-bold"]),
            children: label,
        }))))), delay(() => {
            let props_2, text, value_9;
            return append(singleton((props_2 = ofArray([["options", toArray(props.Options)], ["placeholder", t(props.PlaceholderKey)], ["onChange", props.OnChange], ["noOptionsMessage", (text = t(props.NoOptionsMessage), (props_1) => createElement(NoOptionsMessage, {
                text: text,
                props: props_1,
            }))], (value_9 = props.Value, ["value", (value_9 == null) ? defaultOf() : value_9]), ["isClearable", props.IsClearable], ["isDisabled", props.ComponentState === "disabled"], ["formatOptionLabel", colorDotLabel], ["styles", {
                control: (baseStyles, state) => (Object.assign({}, baseStyles, ((props.ValidationMessage == null) ? defaultStyling(state) : invalidStyling(state)))),
                menuPortal: (baseStyles_1, state_1) => (Object.assign({}, baseStyles_1, {
                    zIndex: 9999,
                })),
            }], ["menuPortalTarget", document.body], ["menuPosition", "fixed"]]), reactApi.createElement(react_select, createObj(props_2)))), delay(() => {
                const matchValue_2 = props.ValidationMessage;
                if (matchValue_2 == null) {
                    return empty();
                }
                else {
                    const message = matchValue_2;
                    return singleton(reactElement("div", {
                        className: join(" ", ["mt-2", "text-red", "text-sm"]),
                        children: message,
                    }));
                }
            }));
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
}

export function MultiSelectWithColor(props) {
    let elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["data-test-id", props.TestId], (elems = toList(delay(() => {
        let matchValue, label;
        return append((matchValue = props.Label, (matchValue == null) ? (empty()) : ((label = matchValue, singleton(reactElement("label", {
            className: join(" ", ["text-sm", "font-bold"]),
            children: label,
        }))))), delay(() => {
            let props_2, text;
            return append(singleton((props_2 = ofArray([["options", toArray(props.Options)], ["placeholder", t(props.PlaceholderKey)], ["onChange", props.OnChange], ["noOptionsMessage", (text = t(props.NoOptionsMessage), (props_1) => createElement(NoOptionsMessage, {
                text: text,
                props: props_1,
            }))], ["value", toArray(props.Value)], ["isClearable", props.IsClearable], ["isMulti", true], ["isDisabled", props.ComponentState === "disabled"], ["formatOptionLabel", colorDotLabel], ["styles", {
                control: (baseStyles, state) => (Object.assign({}, baseStyles, ((props.ValidationMessage == null) ? defaultStyling(state) : invalidStyling(state)))),
                menuPortal: (baseStyles_1, state_1) => (Object.assign({}, baseStyles_1, {
                    zIndex: 9999,
                })),
            }], ["menuPortalTarget", document.body], ["menuPosition", "fixed"]]), reactApi.createElement(react_select, createObj(props_2)))), delay(() => {
                const matchValue_2 = props.ValidationMessage;
                if (matchValue_2 == null) {
                    return empty();
                }
                else {
                    const message = matchValue_2;
                    return singleton(reactElement("div", {
                        className: join(" ", ["mt-2", "text-red", "text-sm"]),
                        children: message,
                    }));
                }
            }));
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
}

export function MultiCreatable(props) {
    let elems;
    const patternInput = useTranslation();
    const t = patternInput[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = toList(delay(() => {
        let matchValue, label;
        return append((matchValue = props.Label, (matchValue == null) ? (empty()) : ((label = matchValue, singleton(reactElement("label", {
            className: join(" ", ["text-sm", "font-bold"]),
            children: label,
        }))))), delay(() => {
            let props_2, text;
            return append(singleton((props_2 = ofArray([["options", toArray(props.Options)], ["placeholder", t(props.PlaceholderKey)], ["onChange", props.OnChange], ["onCreateOption", props.OnCreateOption], ["noOptionsMessage", (text = t(props.NoOptionsMessage), (props_1) => createElement(NoOptionsMessage, {
                text: text,
                props: props_1,
            }))], ["value", toArray(props.Value)], ["isClearable", props.IsClearable], ["isMulti", true], ["isDisabled", props.ComponentState === "disabled"], ["formatCreateLabel", (value_12) => {
                const arg_1 = {
                    value: value_12,
                };
                return patternInput[1].t("select.create_value", arg_1);
            }], ["styles", {
                control: (baseStyles, state) => (Object.assign({}, baseStyles, defaultStyling(state))),
                menuPortal: (baseStyles_1, state_1) => (Object.assign({}, baseStyles_1, {
                    zIndex: 9999,
                })),
            }], ["menuPortalTarget", document.body], ["menuPosition", "fixed"]]), reactApi.createElement(creatable, createObj(props_2)))), delay(() => {
                const matchValue_1 = props.ValidationMessage;
                if (matchValue_1 == null) {
                    return empty();
                }
                else {
                    const message = matchValue_1;
                    return singleton(reactElement("div", {
                        className: join(" ", ["mt-2", "text-red", "text-sm"]),
                        children: message,
                    }));
                }
            }));
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
}

